module.exports = __webpack_public_path__ + "img/6.f325bf5d.webp";